
const useAutoClassGallery = ({ itemData, chosenImage, open, setOpen, currentImageIndex = -1, setCurrentImageIndex, onDeleteFile, setCurrentImage}) => {
    const isStartOfList = currentImageIndex === 0;
    const isEndOfList = currentImageIndex === itemData.length - 1;

    /**
     * handlePrevImage - set the next image to the gallery view
     * @param isStartOfList - boolean flag represents if the images was the first image
     */
    const handleNextImage = (isStartOfList = false) => {
        if (!isStartOfList) {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % itemData.length);
        }

    };

    /**
     * handlePrevImage - set the previous image to the gallery view
     */
    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            (prevIndex === 0 ? itemData.length - 1 : prevIndex - 1)
        );
    };

    /**
     * findChosenImageIndex - find the index of the chosen image
     */
    const findChosenImageIndex = () => {
        const index = itemData.findIndex((item) => item.client_id === chosenImage.client_id);

        setCurrentImageIndex(index);

        return index;
    };

    /**
     * handleDeleteBtnClick - delete the a chosen image
     * @param imageToDelete - image details
     */
    const handleDeleteBtnClick = (imageToDelete) => {
        onDeleteFile(imageToDelete);
        isStartOfList ? handleNextImage(isStartOfList) : handlePrevImage();
    };

    /**
     * handleOpenGalleryBtnClick - set the chosen image and its index, set open to the modal of the image gallery
     */
    const handleOpenGalleryBtnClick = () => {
        const imageIndex = findChosenImageIndex();

        setCurrentImage(itemData[imageIndex]);
        setCurrentImageIndex(imageIndex);
        setOpen(true);
    };

    /**
     * closeModalByScreenSize - close the modal if the screen size too small
     */
    const closeModalByScreenSize = () => {
        const viewportWidth = window.innerWidth;

        (viewportWidth >= 0) && (viewportWidth <= 800) && setOpen(false);
    };


    return ({currentImageIndex,
        handleNextImage,
        handlePrevImage,
        findChosenImageIndex,
        setCurrentImageIndex,
        isStartOfList,
        isEndOfList,
        open,
        setOpen,
        handleDeleteBtnClick,
        handleOpenGalleryBtnClick,
        closeModalByScreenSize});
};

export default useAutoClassGallery;
